import i18n from '@dms/i18n';

import {convertKwToHP} from './convertKwToHp';

/**
 * Format power with horsepower
 * @param kw - Kilowatts
 * @returns Power with horsepower
 */
export const formatPowerWithHorsepower = (kw: number): string => {
  const hp = convertKwToHP(kw);
  return `${kw} ${i18n.t('general.metric.kW')} / ${hp} ${i18n.t('general.metric.HP')}`;
};
